import React from "react";
import styles from "./home.module.css";
import VenuesMap from "../../components/VenuesMap";

const Home: React.FC = () => {
  const churchLocation = 'https://maps.app.goo.gl/zyXMKGJQcVMKjnYN9';
  const venueLocation = 'https://www.google.com/maps/place/Springdale+Station/@30.262408,-97.6991053,1933m/data=!3m2!1e3!4b1!4m6!3m5!1s0x8644b678e4902995:0x813d664c9375ea86!8m2!3d30.262408!4d-97.6965304!16s%2Fg%2F11gdrv_yh5?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D';
  const dayAfterLocation = 'https://www.google.com/maps/search/?api=1&query=2405+Sisterdale+Lane+Austin+TX';

  return (
    <>
      <section className={styles.hero}>
        <div className={styles.innerContainer}>
          <div className={styles.info}>
            <div className={styles.and}>&</div>
            <div className={styles.name}>ALEXANDRIA DAGGETT</div>
            <div className={styles.date}>Saturday March 14th 2026</div>
            <div className={styles.date}>Austin, TX</div>
            <div className={styles.name}>MORGAN LEE</div>
          </div>
          <img className={styles.couple} src="/assets/animated-couple.gif" />
        </div>
      </section>
      <section className={`${styles.details} container`}>
        <div className={styles.section}>
          <div>
            <div className={styles.detailsTitle}>Church</div>
            <div className={styles.detailsInfo}>
              <p>Our celebration will begin at 1:00 PM with a Catholic Mass at Saint Albert the Great Catholic Church, marking the start of our journey as a married couple. Mass starts promptly at 1:00 PM in the main sanctuary. Please be sure to arrive at least 15 minutes early. We can't wait to welcome you there! <a href="https://maps.app.goo.gl/zyXMKGJQcVMKjnYN9" target="_blank" rel="noopener noreferrer">2021 Bittern Hollow, Austin, TX 78758</a>.</p>
              <button
                className="primary-btn"
                onClick={() => window.open(churchLocation, '_blank')}
              >
                Get Directions
              </button>
            </div>
          </div>
          <img className={styles.image} src="/assets/church.png"></img>
        </div> 

        <div className={styles.section}>
          <a href={venueLocation} target="_blank"><img className={styles.image} src="/assets/springdale-station.png"></img></a>
          <div>
            <div className={styles.detailsTitle}>Reception</div>
            <div className={styles.detailsInfo}>
              <p>Following the ceremony, we invite you to join us for a lively cocktail hour and reception at Springdale Station, located at <a href={venueLocation} target="_blank">979 Springdale Rd, Suite #160, Austin, TX 78702</a>. Cocktail hour with light refreshments will be 4:00 PM - 5:00 PM with dinner to follow. We encourage you to bring your best moves to the dance floor as we celebrate together into the night.</p>
              <button
                className="primary-btn"
                onClick={() => window.open(venueLocation, '_blank')}
              >
                Get Directions
              </button>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <div>
            <div className={styles.detailsTitle}>Kick On BBQ</div>
            <div className={styles.detailsInfo}>
              <p>Since many of our family and friends will be flying in from abroad and afar, we would love to spend more time with you all. You are all invited to our house on Sunday, March 15th, for an Aussie-style BBQ at <a href={dayAfterLocation} target="_blank">2405 Sisterdale Lane, Austin, TX 78754</a>. Kicking off at 11:00 AM till late. We've got the food covered and a couple of brews, but please bring your own favorite bevy!</p>
              <button
                className="primary-btn"
                onClick={() => window.open(dayAfterLocation, '_blank')}
              >
                Get Directions
              </button>
            </div>
          </div>
          <img className={styles.image} src="/assets/aussie-bbq.png"></img>
        </div> 
      </section>
      <VenuesMap className={styles.mapContainer} />

    </>
  );
};

export default Home;
